import cloudStore from "../CloudStore";
import articlesStore from "./ArticlesStore";

export function sortOnPriority(array) {
  return array.sort((a, b) => b.priority - a.priority);
}

export function getPrintgroupsFromStores() {
  function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  let printTagsFromPrinters = cloudStore.merchant.printers.reduce((printgroups, printer) => {
    return printgroups.concat(
      printer.printer_tags.map((printTag) => {
        return printTag.tag;
      })
    );
  }, []);

  let printgroups = Object.keys(articlesStore.printgroups)
    .map((printgroup) => printgroup)
    .concat(printTagsFromPrinters);

  return printgroups.filter(onlyUnique);
}

export function getSupergroupsFromStores() {
  const supergroups = Object.keys(articlesStore.supergroups).map(
    (supergroupKey) => articlesStore.supergroups[supergroupKey]
  );
  supergroups.sort((a, b) => b.priority - a.priority);
  return supergroups;
}

export function getTranslationValue(translationObjectType, idType, currentLanguage, article, whenEmptyValue) {
  return currentLanguage === cloudStore.merchant.default_language
    ? article[translationObjectType]
    : articlesStore.translations[article[idType]]?.[currentLanguage] != null
    ? articlesStore.translations[article[idType]]?.[currentLanguage]
    : whenEmptyValue;
}
